// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"416":"ff073e3c","651":"72256fcb"}[chunkId] + ".chunk.js";
};